// extracted by mini-css-extract-plugin
module.exports = {"container":"Blob_container__UARVX","blobFirst":"Blob_blobFirst__f7mDJ","blobInner":"Blob_blobInner__yUBwF","blobSecond":"Blob_blobSecond___T1Iu"};